export const OVERVIEW_SORTER_KEY = "overviewSorter";
export const ARCHIVE_SORTER_KEY = "archiveSorter";
